(function ($) {
  $(window).on('load', function () {
    $('.gallery.grid').masonry({
      itemSelector: '.grid-item',
      columnWidth: '.grid-sizer',
      percentPosition: true,
    });
    initPhotoSwipeFromDOM('.gallery');
    $('.news-related-slider').slick({
      arrows: true,
      dots: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      adaptiveHeight: true,
      swipeToSlide: true,
      autoplay: true,
      autoplaySpeed: 3000,
      infinite: false,
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          }
        },
      ],
    });
  });
})($);